import { ComponentLoggingEventParams } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/types";
import { getSpacingPixels } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Carousel/__internal__/getSpacingPixels";
import { Core } from "@faire/slate/foundation/color";
import { DisplayPageType } from "@faire/web-api--source/indigofair/data/DisplayPageType";
import { ICarouselStyle } from "@faire/web-api--source/indigofair/data/ICarouselStyle";
import { Spacing } from "@faire/web-api--source/indigofair/data/Spacing";
import { ResponsiveProp } from "@faire/web/slate/Theme/ResponsiveProp";

export const getCarouselTileSpacing = (
  tileSpacing: keyof typeof Spacing | undefined
): number | undefined => {
  return tileSpacing ? getSpacingPixels(tileSpacing) : undefined;
};

export const getCarouselLoop = (
  loopBehavior: keyof typeof ICarouselStyle.LoopBehavior | undefined
): ResponsiveProp<boolean> | undefined => {
  switch (loopBehavior) {
    case ICarouselStyle.LoopBehavior.NO_LOOP:
      return { mobileAndAbove: false };
    case ICarouselStyle.LoopBehavior.INFINITE:
      return { mobileAndAbove: true };
    default:
      return;
  }
};

export const getCarouselDragFree = (
  transitionStyle:
    | keyof typeof ICarouselStyle.CarouselTransitionStyle
    | undefined
): ResponsiveProp<boolean> | undefined => {
  switch (transitionStyle) {
    case ICarouselStyle.CarouselTransitionStyle.SCROLL:
      return { mobileAndAbove: true };
    case ICarouselStyle.CarouselTransitionStyle.SNAP:
      return { mobileAndAbove: false };
    default:
      return;
  }
};

export const getCarouselShowNavigationArrows = (
  navigationControl: keyof typeof ICarouselStyle.NavigationControl | undefined,
  loggingData?: ComponentLoggingEventParams
): ResponsiveProp<boolean> | undefined => {
  switch (navigationControl) {
    case ICarouselStyle.NavigationControl.NO_CONTROLS:
      return { mobileAndAbove: false };
    case ICarouselStyle.NavigationControl.ARROWS:
      return { mobileAndAbove: true };
    default:
      if (
        loggingData?.view_display_page === DisplayPageType.SEARCH_PAGE &&
        loggingData.section_type === "FilterablePaginatedSection"
      ) {
        return { mobileAndAbove: false, desktopAndAbove: true };
      }
      return;
  }
};

export const getCarouselControlsVariant = (
  navigationControl: keyof typeof ICarouselStyle.NavigationControl | undefined
): string | undefined => {
  if (
    navigationControl ===
    ICarouselStyle.NavigationControl.DEFAULT_SECONDARY_NAVIGATION_CONTROL
  ) {
    return Core.text.primaryInverse;
  } else if (
    navigationControl ===
    ICarouselStyle.NavigationControl.DEFAULT_PRIMARY_NAVIGATION_CONTROL
  ) {
    return Core.text.primary;
  } else {
    return undefined;
  }
};
